import { Component, Input, ViewEncapsulation } from "@angular/core";
import { OfficerRequestApiModel } from "../../models";
@Component({
    selector: "app-current-committee-officer-information",
    templateUrl: "./current-committee-officer-information.component.html",
    styleUrls: ["./current-committee-officer-information.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class CurrentCommitteeOfficerInformationComponent {
    @Input() officers: OfficerRequestApiModel[];
}
